import { useUser } from '../useUser'
import type { ListActionOptions } from './types'
import type { ListActionResult } from '../types/QueryInput'
import { useListAction } from './index'

export const useListActionBrowser = (props: ListActionOptions): ListActionResult => {
  //get the timezone
  //needed for dynamic date filter
  const { user } = useUser()
  const timeZone = user?.timeZone

  return useListAction({ ...props, timeZone })
}
